/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';

/**
 * A settings icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function SettingsIcon({ size = 'small', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      // @ts-ignore
      sx={{
        width: sizes[size],
        height: sizes[size],
        verticalAlign: 'middle',
      }}
      viewBox="0 0 20 20"
      fill="none"
      {...rest}
    >
      <path
        fill="currentColor"
        d="M8.558.62c1.058-.16 1.773-.16 2.832 0 .207.033.37.197.398.405l.403 2.93c.04.289.21.524.465.646a.787.787 0 00.757-.037l2.49-1.5a.48.48 0 01.572.064 9.682 9.682 0 011.757 2.263.473.473 0 01-.066.555l-1.982 2.13a.842.842 0 00-.205.774.82.82 0 00.507.593l2.658 1.029c.196.076.318.27.302.479a9.787 9.787 0 01-.649 2.823.47.47 0 01-.482.298l-2.819-.246a.8.8 0 00-.699.303.843.843 0 00-.147.792l.855 2.72a.473.473 0 01-.183.53 9.355 9.355 0 01-2.584 1.258.48.48 0 01-.536-.192l-1.55-2.37c-.309-.471-1.048-.471-1.356 0l-1.55 2.37a.476.476 0 01-.537.192 9.352 9.352 0 01-2.584-1.257.476.476 0 01-.183-.531l.855-2.72a.84.84 0 00-.147-.792.788.788 0 00-.699-.303l-2.819.246a.479.479 0 01-.482-.298 9.787 9.787 0 01-.649-2.823.477.477 0 01.302-.48l2.658-1.028c.26-.1.443-.316.507-.593a.842.842 0 00-.205-.774l-1.982-2.13a.474.474 0 01-.066-.555 9.686 9.686 0 011.758-2.263.474.474 0 01.571-.063l2.49 1.499c.234.142.51.155.757.037a.823.823 0 00.465-.645l.403-2.931a.476.476 0 01.4-.404zm2.34.89a7.065 7.065 0 00-1.849 0l-.354 2.575a1.78 1.78 0 01-.995 1.37c-.53.255-1.15.225-1.654-.08L3.872 4.068A8.738 8.738 0 002.715 5.56l1.741 1.87c.407.438.57 1.048.436 1.633a1.779 1.779 0 01-1.089 1.264l-2.323.9c.076.642.22 1.269.43 1.87l2.46-.213a1.743 1.743 0 011.52.652 1.8 1.8 0 01.311 1.67l-.748 2.38a8.377 8.377 0 001.7.827l1.35-2.063c.328-.5.878-.8 1.471-.8.592 0 1.142.3 1.47.8l1.351 2.063a8.403 8.403 0 001.7-.827l-.749-2.38a1.799 1.799 0 01.313-1.67c.368-.46.94-.71 1.52-.652l2.46.214c.21-.602.353-1.23.428-1.871l-2.323-.9a1.8 1.8 0 01-.653-2.896l1.741-1.871a8.688 8.688 0 00-1.157-1.492l-2.174 1.309a1.738 1.738 0 01-1.654.08 1.783 1.783 0 01-.995-1.371zm-.924 5.466a3 3 0 110 6 3 3 0 010-6zm0 1a2 2 0 10-.001 3.999 2 2 0 00.001-3.999z"
      />
    </svg>
  );
}
